import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = 'el_token';

export const getToken = () => {
  try { return JSON.parse(localStorage.getItem(TOKEN_KEY)); } catch { return null; }
};
export const setToken = (t) => {
  try { if (t) localStorage.setItem(TOKEN_KEY, JSON.stringify(t)); else localStorage.removeItem(TOKEN_KEY); } catch {}
};

const client = axios.create({ baseURL: API_BASE });
client.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const api = {
  signup: (name, email, password) => client.post('/auth/signup', { name, email, password }).then(r => r.data),
  login: (email, password) => client.post('/auth/login', { email, password }).then(r => r.data),
  me: () => client.get('/auth/me').then(r => r.data),
  updateMe: (payload) => client.patch('/auth/me', payload).then(r => r.data),
  buyCredits: (pack) => client.post('/auth/buy_credits', { pack }).then(r => r.data),
  feed: () => client.get('/songs/feed').then(r => r.data),
  mine: () => client.get('/songs/mine').then(r => r.data),
  song: (id) => client.get(`/songs/${id}`).then(r => r.data),
  updateSong: (id, payload) => client.patch(`/songs/${id}`, payload).then(r => r.data),
  createSong: (payload) => client.post('/songs', payload).then(r => r.data),
  likeSong: (id) => client.post(`/songs/${id}/like`).then(r => r.data),
  deleteSong: (id) => client.delete(`/songs/${id}`).then(r => r.data),
  genLyrics: (payload) => client.post('/ai/lyrics', payload).then(r => r.data),
  // Suno generation
  refreshSong: (id) => client.post(`/songs/${id}/refresh`).then(r => r.data),
  // social
  profile: (userId) => client.get(`/users/${userId}`).then(r => r.data),
  followUser: (userId) => client.post(`/users/${userId}/follow`).then(r => r.data),
  // playlists
  myPlaylists: () => client.get('/playlists/mine').then(r => r.data),
  createPlaylist: (payload) => client.post('/playlists', payload).then(r => r.data),
  getPlaylist: (id) => client.get(`/playlists/${id}`).then(r => r.data),
  updatePlaylist: (id, payload) => client.patch(`/playlists/${id}`, payload).then(r => r.data),
  deletePlaylist: (id) => client.delete(`/playlists/${id}`).then(r => r.data),
  addSongToPlaylist: (pid, songId) => client.post(`/playlists/${pid}/songs/${songId}`).then(r => r.data),
  removeSongFromPlaylist: (pid, songId) => client.delete(`/playlists/${pid}/songs/${songId}`).then(r => r.data),
  // comments
  listComments: (songId) => client.get(`/songs/${songId}/comments`).then(r => r.data),
  addComment: (songId, text) => client.post(`/songs/${songId}/comments`, { text }).then(r => r.data),
  deleteComment: (cid) => client.delete(`/comments/${cid}`).then(r => r.data),
};

export default api;
